import { render, staticRenderFns } from "./ServiceAreasBlockoutDayPage.vue?vue&type=template&id=f81fbc96&scoped=true&"
import script from "./ServiceAreasBlockoutDayPage.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasBlockoutDayPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasBlockoutDayPage.vue?vue&type=style&index=0&id=f81fbc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81fbc96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81fbc96')) {
      api.createRecord('f81fbc96', component.options)
    } else {
      api.reload('f81fbc96', component.options)
    }
    module.hot.accept("./ServiceAreasBlockoutDayPage.vue?vue&type=template&id=f81fbc96&scoped=true&", function () {
      api.rerender('f81fbc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/BlockoutDays/ServiceAreasBlockoutDayPage.vue"
export default component.exports